export const ADMIN_ROUTE_NAMES = {
  adminOffers: 'accAdministrationOffers',
  adminReviews: 'accAdministrationReviews',
  adminElabels: 'accAdministrationELabels',
  adminImages: 'accAdministrationImages',
  adminRequests: 'accAdministrationRequests',
  potentialProducers: 'accAdministrationRequestsPotentialProducers',
  adminCompanies: 'accAdministrationCompanies',
  adminUsers: 'accAdministrationUsers',
  adminTradeOffers: 'accAdministrationRetailOffers',
  adminRetailPublicPages: 'accAdministrationRetailPublicPages',
  adminWineSites: 'accAdministrationWineSites',
  adminPriceSources: 'accAdministrationPriceSources',
  adminMentions: 'accAdministrationMentions',
  adminMentionsPrices: 'accAdministrationMentionsPrices',
  adminMentionsFacts: 'accAdministrationMentionsFacts',
  adminClusters: 'accAdministrationClusters',
  adminVerifiedRelations: 'accAdministrationVerifiedRelations',
  adminMentionCluser: 'accAdministrationMentionsCluster',
  adminLinkMentions: 'accAdministrationLinkMentions',
}
